import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { IListModalModel } from 'src/app/core/models/interfaces/list-modal-component-model';
import { INewImageModel } from 'src/app/core/models/interfaces/new-image-model';
import { LoadingService } from 'src/app/core/services/loading.service';
import { MediaService } from 'src/app/core/services/media.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { DeviceList } from '../../models/profile';
import { QuestionErrorService } from '../../services/question-error.service';

@Component({
  selector: 'app-error-log-save',
  templateUrl: './error-log-save.component.html',
  styleUrls: ['./error-log-save.component.scss'],
})
export class ErrorLogSaveComponent extends BaseModal implements OnInit {

  files: Array<any> = [];
  images: Array<INewImageModel> = []
  visibleImageCount = 0
  selectedImage: string = null
  deviceId: string;
  desc: string;
  errorType: any = "Application";
  deviceList: Array<DeviceList> = [];
  constructor(
    private errorService: QuestionErrorService,
    private mediaService: MediaService,
    private modalService: ModalService,
    private loadingService: LoadingService,
    private translate: TranslateService,
    private questionErrorService: QuestionErrorService,
    private toastService: ToastService) {
    super()
    super._modalService = modalService
  }

  ngOnInit() { }

  ionViewDidEnter() {
    this.setFormGroup();
    this.getDeviceList();
  }

  getDeviceList() {
    this.loadingService.showLoading();
    this.errorService.getDeviceList().subscribe(e => {
      if (e.IsSuccess) {
        this.deviceList = e.Data;
      }
      this.loadingService.hideLoading();
    });
  }

  selectedDevice;
  openDeviceList() {
    this.loadingService.showLoading();
    this.modalService.presentListModal({
      confirmBtnText: this.translate.instant("general.submit"),
      hasConfirmBtn: false,
      isFullscreen: false,
      isMultiple: false,
      title: this.translate.instant("profile.device-list"),
      itemList: this.deviceList.map(t => {
        return {
          id: t.SensorId,
          value: t.DeviceId,
          isChecked: this.selectedDevice?.some(a => a.Id === t.SensorId)
        } as IListModalModel
      })
    }).then(modalRes => {
      this.loadingService.hideLoading()
      modalRes.modalObj.onDidDismiss().then(dismiss => {
        if (dismiss.role === 'itemSelected') {
          this.selectedDevice = dismiss.data.selectedItem
        }
      });
    });
  }
  setFormGroup() {
  }
  requiredDevice: boolean = false
  requiredDesc: boolean = false
  save() {
    let isValid = true;
    if (this.errorType = "Device") {
      if (!this.selectedDevice) {
        isValid = false;
        this.requiredDevice = true;
      }
    }
    if (!this.desc) {
      isValid = false;
      this.requiredDesc = true;
    }
    if (isValid) {
      this.requiredDevice = false;
      this.requiredDesc = false;
      let formData: FormData = new FormData();
      let deviceType = this.deviceList.find(e => e.SensorId == this.selectedDevice?.id)?.DeviceType
      formData.append("DeviceId", this.selectedDevice?.id.toString());
      formData.append("Description", this.desc);
      formData.append("DeviceType", deviceType);
      formData.append("ErrorType", this.errorType);
      this.images.forEach(e => {
        formData.append("Files", e.image, `image_${Date.now()}.${e.format}`);
      });
      this.loadingService.showLoading();
      this.questionErrorService.saveErrorLog(formData).subscribe(res => {
        this.loadingService.hideLoading();
        if (res.IsSuccess) {
          this.dismiss(null, "success");
        } else {
          this.toastService.PresentBasicToast({
            message: this.translate.instant("error-log.failed"),
            type: Message_Type.DANGER,
            duration: 3500,
          })
        }
      });
    }


  }

  openMediaOptions() {
    this.mediaService.openAddMediaSheet().subscribe(
      (res: string) => {
        if (res == "camera") {
          this.mediaService.openAddPhotoSheet().subscribe(
            (res: INewImageModel) => {
              if (!Array.isArray(this.images))
                this.images = []
              this.images.push(res)
            }, err => {
            })
        } else if (res == "video") {
          this.mediaService.captureVideo().subscribe(res => {
            if (!Array.isArray(this.images))
              this.images = []
            this.images.push(res)
          });
        } else if (res == "audio") {
          this.mediaService.captureAudio().subscribe(res => {
            if (!Array.isArray(this.images))
              this.images = []
            this.images.push(res)
          });
        }
      }, err => {
      })
  }

  openMediaGallery() {
    this.mediaService.openMediaGalleryModal({ imageList: this.images }).then(response => {
      response.modalObj.onDidDismiss().then(dismiss => {
        if (dismiss && dismiss.role === "imageListChanged") {
          this.images = dismiss.data
        }
      })
    })
  }

}
